import { GET_COUNTRIES, COUNTRIES_ERROR, GET_CITIES } from '../types';

export default (state, action) => {
  switch (action.type) {
    case GET_COUNTRIES:
      return {
        ...state,
        countries: action.payload,
        loading: false
      };
    case GET_CITIES:
      return {
        ...state,
        cities: action.payload,
        loading: false
      };
    case COUNTRIES_ERROR:
      return {
        ...state,
        error: action.payload
      };
    default:
      return state;
  }
};
